import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Button } from './ui/button';

// Secção "Novidades" — os cartões "Novo na loja" (feltro + Physioderm).
// Andava dentro de Products.jsx, depois da grelha de marcas. Decisão da
// Licínia, 23/09/2026: passa a secção própria, ANTES de "Produtos" (mesma
// ordem do menu: Sobre Nós, Novidades, Produtos). Texto e aspecto tal e
// qual — só mudou o sítio. `scroll-mt-24` (96px) é para o cabeçalho fixo
// (h-20 = 80px) não tapar o topo da secção ao saltar pela âncora.
//
// Título acrescentado depois, tambem por pedido da Licinia: mesmo padrao
// das outras seccoes (etiqueta + h2 + traco), como o "Portfolio &
// Inspiracao" / "Projetos que inspiram" do Portfolio.jsx. Azul para nao
// repetir o laranja do "Sobre Nos" mesmo antes nem o verde-esmeralda do
// "Produtos" logo a seguir. Com o h2 a dizer "Novidades na loja", a
// etiqueta "Novo na loja" DENTRO de cada cartao passou a repetir-se —
// tirada dos dois.
const Novidades = () => {
  const { language } = useLanguage();

  return (
    <section id="novidades" className="scroll-mt-24 py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-blue-100 text-blue-600 text-sm font-semibold rounded-full mb-4">
            {language === 'pt' ? 'Novidades' : "What's new"}
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {language === 'pt' ? 'Novidades na loja' : 'New in store'}
          </h2>
          <div className="w-20 h-1 bg-gradient-to-r from-blue-500 to-cyan-500 mx-auto rounded-full" />
        </div>

        {/* Feltro de protecao autoadesivo: JA' A VENDA na loja (23/09/2026).
            Ate' aqui era "Vem ai'"/produto em estudo; a Licinia confirmou a venda
            e o texto passou a copy de venda (pigmentos-comercial, 23/09/2026). */}
        <div className="rounded-2xl overflow-hidden bg-gray-900 shadow-xl">
          <div className="grid md:grid-cols-[280px_1fr] gap-0 items-stretch md:min-h-[288px]">
            <img
              src="/assets/feltro-protecao-poster.jpg"
              alt={language === 'pt'
                ? 'Feltro de proteção autoadesivo aplicado num envidraçado'
                : 'Self-adhesive protective felt applied on a glazed surface'}
              className="w-full h-56 md:h-[288px] object-cover"
              loading="lazy"
            />
            <div className="p-8 md:p-10">
              <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
                {language === 'pt' ? 'Feltro de proteção autoadesivo' : 'Self-adhesive protective felt'}
              </h3>
              <p className="text-gray-300 leading-relaxed mb-6 max-w-2xl">
                {language === 'pt'
                  ? 'Cola-se ao pavimento, às escadas e aos envidraçados, sai sem deixar resíduos e dá para reutilizar. Já à venda na Pigmentos, em Oeiras.'
                  : 'It sticks to floors, stairs and glazing, comes off without residue and can be reused. Already for sale at Pigmentos, in Oeiras.'}
              </p>
              <Button
                asChild
                className="rounded-xl py-5 px-7 text-white bg-gradient-to-r from-orange-500 to-red-500 transition-all duration-300 hover:shadow-lg hover:opacity-90"
              >
                <a href="/feltro-de-protecao/" className="flex items-center justify-center gap-2">
                  {language === 'pt' ? 'Conhecer o feltro de proteção' : 'See the protective felt'}
                </a>
              </Button>
            </div>
          </div>
        </div>

        {/* Novo na loja: sistema Physioderm (23/09/2026). Copy já aprovada pelo
            pigmentos-comercial e pelo pigmentos-fiscalizador, não se reescreve. */}
        <div className="mt-8 rounded-2xl overflow-hidden bg-white border border-gray-100 shadow-lg">
          <div className="grid md:grid-cols-[280px_1fr] gap-0 items-stretch md:min-h-[288px]">
            <img
              src="/assets/guias/physioderm-trio.webp"
              alt={language === 'pt'
                ? 'Os três produtos do sistema Physioderm: Sansibon, Rapituff e Curea'
                : 'The three Physioderm system products: Sansibon, Rapituff and Curea'}
              className="w-full h-56 md:h-[288px] object-cover"
              loading="lazy"
            />
            <div className="p-8 md:p-10">
              <span className="inline-block px-4 py-1.5 bg-orange-100 text-orange-600 text-sm font-semibold rounded-full mb-4">
                {language === 'pt' ? 'Já disponível na nossa loja' : 'Now available in our store'}
              </span>
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
                {language === 'pt' ? 'Sistema Physioderm' : 'Physioderm system'}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6 max-w-2xl">
                {language === 'pt'
                  ? 'Para quem trabalha todos os dias com tinta, resina ou cola, chegou à Pigmentos o sistema Physioderm de proteção, limpeza e cuidado da pele. Conheça os produtos disponíveis.'
                  : 'For anyone working every day with paint, resin or glue, the Physioderm skin protection, cleaning and care system has arrived at Pigmentos. Discover the available products.'}
              </p>
              <Button
                asChild
                className="rounded-xl py-5 px-7 text-white bg-gradient-to-r from-orange-500 to-red-500 transition-all duration-300 hover:shadow-lg hover:opacity-90"
              >
                <a href="/physioderm/" className="flex items-center justify-center gap-2">
                  {language === 'pt' ? 'Ver o sistema Physioderm' : 'See the Physioderm system'}
                </a>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Novidades;
